export function setupEmployeeFilters (instance) {
  instance.filter("display_name", (value) => {
    if (value) {
      return `${value.lastname}, ${value.firstname}`
    }
  });
}
